export default {
  plural: 'Правила',
  materialRules: 'Правила матеріалів',
  attachmentRules: 'Правила стикування',
  socketAcceptances: 'Допуски сокетів',
  fields: {
    code: 'Код',
    meshPattern: 'Патерн меша',
    materialPattern: 'Патерн матеріалу',
    hostPattern: 'Патерн хоста',
    partPattern: 'Патерн частини',
    matchType: 'Тип збігу',
    mateRotationDeg: 'Поворот стикування (°)',
    mirrorOnMate: 'Дзеркалити при стикуванні',
    nodeId: 'ID вузла',
    socketPattern: 'Патерн сокета',
    mode: 'Режим'
  },
  matchType: {
    prefix: 'Префікс',
    exact: 'Точне'
  },
  acceptanceMode: {
    acceptByRule: 'За правилом',
    curatedOnly: 'Лише вручну'
  },
  scope: {
    label: 'Область',
    global: 'Глобально',
    company: 'Компанія',
    configurator: 'Конфігуратор'
  },
  addRow: 'Додати рядок',
  save: 'Зберегти',
  unsavedChanges: 'Незбережені зміни',
  override: 'Перевизначити',
  inheritedFrom: 'Успадковано з {{origin}}',
  noRules: 'Правил поки немає',
  selectCompany: 'Виберіть компанію',
  materialRulesInactiveBanner:
    'Правила матеріалів зараз не впливають на віджет — матеріали зон керуються через дозволені матеріали шаблону зони (перевірено 2026-08-14).',
  contextual: {
    inheritedTitle: 'Успадковані правила',
    localTitle: 'Локальні правила (цей конфігуратор)',
    levelGlobal: 'Глобальне',
    levelCompany: 'Компанія',
    editOnRulesPage: 'Редагувати на сторінці правил',
    noInherited: 'Успадкованих правил немає',
    noLocal: 'Локальних правил поки немає',
    addAttachmentRule: 'Додати правило кріплень',
    materialsPointer: 'Матеріалами зон керуйте в розділі',
    materialRuleInactive: 'неактивно',
    hostSocket: 'Сокет-хост',
    connector: 'Конектор',
    connectorSelectsParts: 'Обере деталі:',
    socketRulesTitle: 'Правила цього сокета',
    socketRulesHint:
      'Які конектори сюди кріпляться. Правила Global і Company доступні лише для читання.',
    zoneRulesTitle: 'Правила цієї зони',
    zoneRulesHint:
      'Правила матеріалів, що посилаються на цю зону. На віджет поки не впливають.',
    allowConnector: 'Дозволити конектор',
    levelLocal: 'Локальне',
    alreadyAllowed: 'вже дозволений',
    noSocketRules: 'Для цього сокета правил немає',
    advanced: 'Додатково',
    save: 'Зберегти правило',
    cancel: 'Скасувати',
    close: 'Закрити',
    remove: 'Видалити',
    preview: {
      title: 'Живий перегляд',
      noViewer: 'Опублікованого в’юера ще немає — віджету нема з чим звірятись',
      noTargets:
        'Цей hostPattern не охоплює жодного сокета поточного дефолтного варіанта — правило піде в нікуди',
      noPartsYet: 'Сокет підпадає під правило — наразі в ньому немає деталей.',
      nested: 'вкладений',
      curatedOnlyHint:
        'Кандидати за правилами тут не показуються, поки сокет не перемкнено в accept-by-rule',
      savedRefreshed:
        'Правило збережено — нижче кандидати після перезавантаження в’юера'
    }
  }
};
